class CustomFacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);


        const queryString = window.location.search;

        const urlParams = new URLSearchParams(queryString);

        if(urlParams.has('last_added')){

            let last_filter = this.querySelector('#_custom-filters-wrapper').children.item(urlParams.get('last_added'));

            last_filter.querySelector('._custom-collection-filter-container').classList.toggle("show");
            last_filter.querySelector('._custom-collection-filter-content-headline').classList.toggle("active")

            last_filter.querySelector('._custom-toggle-icon').classList.toggle("rotate");

        }

        this.debouncedOnSubmit = debounce((event, input_element) => {
            this.onSubmitHandler(event, input_element);
        }, 500);

        const facetForm = this.querySelector('form');
        facetForm.addEventListener('input',  (event) => {

            const input = event.target;

            this.debouncedOnSubmit(event, input);
        });

        const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
        if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

        const dropdown_buttons = this.querySelectorAll("._custom-collection-filter-content-headline");

        const dropdownList = this.querySelectorAll("._custom-collection-filter-container");

        const toggleIcon = document.querySelectorAll('._custom-toggle-icon');

        dropdown_buttons.forEach((dropdownBtn) => {
            dropdownBtn.addEventListener("click", function () {


                document.querySelectorAll('._custom-collection-filter-container.show').forEach((element) => {
                    if(element != dropdownBtn.parentElement.querySelector('._custom-collection-filter-container')){
                        element.classList.remove("show");
                    }
                });

                document.querySelectorAll('._custom-collection-filter-content-headline').forEach((element) => {
                    if(element != dropdownBtn.parentElement.querySelector('._custom-collection-filter-content-headline')){
                        element.classList.remove("active");
                    }
                });

                document.querySelectorAll('._custom-toggle-icon').forEach((element) => {
                    if(element != dropdownBtn.parentElement.querySelector('._custom-toggle-icon')){
                        element.classList.remove("rotate");
                    }
                });

                dropdownBtn.parentElement.querySelector('._custom-collection-filter-container').classList.toggle("show");
                dropdownBtn.parentElement.querySelector('._custom-collection-filter-content-headline').classList.toggle("active")

                dropdownBtn.parentElement.querySelector('._custom-toggle-icon').classList.toggle("rotate");


            });
        });

        document.addEventListener("click", function (event) {

            const active_dropdown_button = document.querySelector('._custom-collection-filter-content-headline.active');

            const active_dropdown_list = document.querySelector('._custom-collection-filter-container.show');


            if (!active_dropdown_button  || !active_dropdown_list) return;

            if(active_dropdown_button.contains(event.target) || active_dropdown_list.contains(event.target)) return;

            document.querySelectorAll('._custom-collection-filter-container.show').forEach((element) => {
                element.classList.remove("show");
            });

            document.querySelectorAll('._custom-collection-filter-content-headline').forEach((element) => {
                element.classList.remove("active");
            });

            document.querySelectorAll('._custom-toggle-icon').forEach((element) => {
                element.classList.remove("rotate");
            });

        });

        /*
                dropdownBtn.addEventListener("click", function () {
                    if (dropdownList.style.display === "none") {
                        dropdownList.style.display = "block";
                    } else {
                        dropdownList.style.display = "none";
                    }
                });

                dropdownList.addEventListener("click", function (event) {
                    dropdownBtn.innerText = event.target.innerText;
                    dropdownList.style.display = "none";
                }); */






    }

    static setListeners() {
        const onHistoryChange = (event) => {
            const searchParams = event.state ? event.state.searchParams : CustomFacetFiltersForm.searchParamsInitial;
            if (searchParams === CustomFacetFiltersForm.searchParamsPrev) return;
            CustomFacetFiltersForm.renderPage(searchParams, null, false);
        };
        window.addEventListener('popstate', onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }

    static renderPage(searchParams, event,  updateURLHash = true) {
        CustomFacetFiltersForm.searchParamsPrev = searchParams;
        /*const sections = CustomFacetFiltersForm.getSections();
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
        if (countContainer) {
            countContainer.classList.add('loading');
        }
        if (countContainerDesktop) {
            countContainerDesktop.classList.add('loading');
        }

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = (element) => element.url === url;

            CustomFacetFiltersForm.filterData.some(filterDataUrl)
                ? CustomFacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
                : CustomFacetFiltersForm.renderSectionFromFetch(url, event);
        }); */

        if (updateURLHash) CustomFacetFiltersForm.updateURLHash(searchParams);

        location.reload();
    }

    static renderSectionFromFetch(url, event) {
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                CustomFacetFiltersForm.filterData = [...CustomFacetFiltersForm.filterData, { html, url }];
                CustomFacetFiltersForm.renderFilters(html, event);
                CustomFacetFiltersForm.renderProductGridContainer(html);
                CustomFacetFiltersForm.renderProductCount(html);
                if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
            });
    }

    static renderSectionFromCache(filterDataUrl, event) {
        const html = CustomFacetFiltersForm.filterData.find(filterDataUrl).html;
        CustomFacetFiltersForm.renderFilters(html, event);
        CustomFacetFiltersForm.renderProductGridContainer(html);
        CustomFacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    }

    static renderProductGridContainer(html) {
        document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('ProductGridContainer').innerHTML;

        document
            .getElementById('ProductGridContainer')
            .querySelectorAll('.scroll-trigger')
            .forEach((element) => {
                element.classList.add('scroll-trigger--cancel');
            });
    }

    static renderProductCount(html) {
        const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
        const container = document.getElementById('ProductCount');
        const containerDesktop = document.getElementById('ProductCountDesktop');
        container.innerHTML = count;
        container.classList.remove('loading');
        if (containerDesktop) {
            containerDesktop.innerHTML = count;
            containerDesktop.classList.remove('loading');
        }
    }

    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const facetDetailsElements = parsedHTML.querySelectorAll(
            '#CustomFacetFiltersForm .js-filter, #CustomFacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
        );
        const matchesIndex = (element) => {
            const jsFilter = event ? event.target.closest('.js-filter') : undefined;
            return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        };
        const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
        const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

        facetsToRender.forEach((element) => {
            document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
        });

        CustomFacetFiltersForm.renderActiveFacets(parsedHTML);
        CustomFacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender) CustomFacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    }

    static renderActiveFacets(html) {
        const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

        activeFacetElementSelectors.forEach((selector) => {
            const activeFacetsElement = html.querySelector(selector);
            if (!activeFacetsElement) return;
            document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        });

        CustomFacetFiltersForm.toggleActiveFacets(false);
    }

    static renderAdditionalElements(html) {
        const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

        mobileElementSelectors.forEach((selector) => {
            if (!html.querySelector(selector)) return;
            document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        });

        document.getElementById('CustomFacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    }

    static renderCounts(source, target) {
        const targetElement = target.querySelector('.facets__selected');
        const sourceElement = source.querySelector('.facets__selected');

        const targetElementAccessibility = target.querySelector('.facets__summary');
        const sourceElementAccessibility = source.querySelector('.facets__summary');

        if (sourceElement && targetElement) {
            target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
        }

        if (targetElementAccessibility && sourceElementAccessibility) {
            target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
        }
    }

    static updateURLHash(searchParams) {
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    static getSections() {
        return [
            {
                section: document.getElementById('product-grid').dataset.id,
            },
        ];
    }

    createSearchParams(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event, input_element) {
        CustomFacetFiltersForm.renderPage(searchParams, event, input_element);
    }

    onSubmitHandler(event, input_element) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll('facet-filters-form form');
        if (event.srcElement.className == 'mobile-facets__checkbox') {
            const searchParams = this.createSearchParams(event.target.closest('form'));
            this.onSubmitForm(searchParams, event);
        } else {
            const forms = [];
            const isMobile = event.target.closest('form').id === 'CustomFacetFiltersFormMobile';

            sortFilterForms.forEach((form) => {
                if (!isMobile) {
                    if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
                        const noJsElements = document.querySelectorAll('.no-js-list');
                        noJsElements.forEach((el) => el.remove());
                        forms.push(this.createSearchParams(form));
                    }
                } else if (form.id === 'CustomFacetFiltersFormMobile') {
                    forms.push(this.createSearchParams(form));
                }
            });

            let params = forms.join('&');

            if (input_element && input_element.attributes['name'].value !== 'sort_by') {

                const filter_container = input_element.closest('._custom-collection-filter-item');

                const index = Array.from(filter_container.parentNode.children).indexOf(filter_container)

                params = params + '&' + 'last_added' + '=' + index;
            }

            this.onSubmitForm(params, event);
        }
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        CustomFacetFiltersForm.toggleActiveFacets();
        const url =
            event.currentTarget.href.indexOf('?') == -1
                ? ''
                : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        CustomFacetFiltersForm.renderPage(url);
    }
}

CustomFacetFiltersForm.filterData = [];
CustomFacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
CustomFacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', CustomFacetFiltersForm);
CustomFacetFiltersForm.setListeners();


class CustomPriceRange extends HTMLElement {
    constructor() {
        super();
        _defineProperty(this, "selectors", {
            inputs: ['input[type="number"]'],
            ranges: ['input[type="range"]'],
            minRange: '[data-type="min-range"]',
            maxRange: '[data-type="max-range"]',
            minInput: '[data-type="min-input"]',
            maxInput: '[data-type="max-input"]'
        });
        this.domNodes = queryDomNodes(this.selectors, this);
        this.priceGap = parseInt(this.dataset.priceGap);
        this.priceMax = parseInt(this.dataset.priceMax);
        this.domNodes.inputs.forEach(el => el.addEventListener('change', this.onInputChange.bind(this)));
        this.domNodes.ranges.forEach(el => el.addEventListener('input', this.onSliderChange.bind(this)));
        this.setMinAndMaxValues();
    }

    onSliderChange(event) {
        const input = event.currentTarget;
        const type = input.dataset.type;
        const value = Number(input.value);
        const {
            minInput,
            maxInput,
            minRange,
            maxRange
        } = this.domNodes;
        if (type === 'min-range') {
            if (maxRange.value - input.value >= this.priceGap) {
                minInput.value = input.value;
            } else {
                input.value = maxRange.value - this.priceGap;
            }
        }
        if (type === 'max-range') {
            if (input.value - minRange.value >= this.priceGap) {
                maxInput.value = input.value;
            } else {
                input.value = Number(minRange.value) + Number(this.priceGap);
            }
        }
        this.style.setProperty('--from', 100 * minRange.value / this.priceMax + '%');
        this.style.setProperty('--to', 100 * maxRange.value / this.priceMax + '%');
    }
    onInputChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }
    setMinAndMaxValues() {
        const {
            minInput,
            maxInput
        } = this.domNodes;
        if (maxInput.value) minInput === null || minInput === void 0 ? void 0 : minInput.setAttribute('max', Number(maxInput.value) - this.priceGap);
        if (minInput.value) maxInput === null || maxInput === void 0 ? void 0 : maxInput.setAttribute('min', Number(minInput.value) + this.priceGap);
        if (minInput.value === '') maxInput === null || maxInput === void 0 ? void 0 : maxInput.setAttribute('min', 0);
        if (maxInput.value === '') minInput === null || minInput === void 0 ? void 0 : minInput.setAttribute('max', maxInput.getAttribute('max'));
    }
    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute('min'));
        const max = Number(input.getAttribute('max'));
        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}

customElements.define('custom-price-range', CustomPriceRange);


function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}